import { IDeviceConfiguration, IPlaylistItem } from "hooks/useImko";
import { IAbpResponseGet } from "types/IApi";
import AbpAppService from "./AbpAppService";
import { getResponseExceptionMessage } from "./apiSettings";

const service = new AbpAppService("Offer");

export const getOffers = async (params: {
  serverId: string;
  offerCount: number;
  playlistItem?: IPlaylistItem;
  deviceConfiguration?: IDeviceConfiguration;
}): Promise<IAbpResponseGet<any>> => {
  let result = {} as IAbpResponseGet<any>;
  try {
    result = await service.invoke("post", "getOffers", params);
  } catch (error) {
    console.log(getResponseExceptionMessage(error));
  }
  return result;
};

export const getNextOffers = async (params: {
  serverId: string;
  offerCount: number;
}): Promise<IAbpResponseGet<any>> => {
  let result = {} as IAbpResponseGet<any>;
  try {
    result = await service.invoke("get", "getNextOffers", params);
  } catch (error) {
    console.log(getResponseExceptionMessage(error));
  }
  return result;
};
